export default __webpack_public_path__ + "static/Queen-f382eb83d76fc712e2ba0800c7161e80.svg";